import { useEffect } from 'react';

export function useEscapeKey(handler, active = true) {
  useEffect(() => {
    if (!active || typeof window === 'undefined') return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') handler(e);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [handler, active]);
}
